import { useState } from "react";
import { Plus, Edit, Trash, Copy } from "lucide-react";
import quickMessageApi from "../../../../api/quickMessageApi";
import AddQuickMessageModal from "../AddQuickMessageModal";
import CopyShopDataModal from "../CopyShopDataModal";
import { useNotification } from "../../../../hooks/useNotification";

export default function ManageQuickMessageModal({
  shop,
  quickMessages,
  setQuickMessages,
  refreshTags,
}) {
  const { addNotification } = useNotification();

  const [showAddModal, setShowAddModal] = useState(false);
  const [showCopyModal, setShowCopyModal] = useState(false);
  const [editingQuickMessage, setEditingQuickMessage] = useState(null);

  const getQuickMessages = async () => {
    const res = await quickMessageApi.getByShopId(shop?._id);
    if (res.status === 1) setQuickMessages(res.data);
  };

  const handleEditClick = (quickMessage) => {
    setEditingQuickMessage(quickMessage);
    setShowAddModal(true);
  };

  const handleDeleteClick = async (quickMessage) => {
    if (!window.confirm(`Bạn có muốn xoá ${quickMessage.shortcut} không?`))
      return;
    const res = await quickMessageApi.updateById({
      _id: quickMessage._id,
      isDelete: true,
    });
    if (res.status === 1) {
      await getQuickMessages();
      addNotification("Xoá thành công", res.status);
    } else addNotification(res.message, res.status);
  };

  return (
    <>
      <div className="h-full flex items-center justify-center overflow-y-auto">
        <div className="w-full h-full">
          <div className="border-b pb-4 flex gap-2">
            <button
              onClick={() => setShowAddModal(true)}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors duration-200"
            >
              <Plus size={20} />
              Thêm
            </button>
            <button
              onClick={() => setShowCopyModal(true)}
              className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors duration-200"
            >
              <Copy size={20} />
              Sao chép
            </button>
          </div>
          <div className="overflow-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-gray-100 text-gray-700">
                  <th className="px-4 py-3 text-left">STT</th>
                  <th className="px-4 py-3 text-left">Ký tự tắt</th>
                  <th className="px-4 py-3 text-left">Tin nhắn</th>
                  <th className="px-4 py-3 text-left">Hành động</th>
                </tr>
              </thead>
              <tbody>
                {quickMessages.map((row, index) => (
                  <tr
                    key={row._id}
                    className="border-t hover:bg-gray-50 transition-colors duration-200"
                  >
                    <td className="px-4 py-3">{index + 1}</td>
                    <td className="px-4 py-3">{row.shortcut}</td>
                    <td
                      className="px-4 py-3 truncate max-w-80"
                      title={row.content}
                    >
                      {row.content}
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-2">
                        <button
                          className="text-blue-600 hover:text-blue-800"
                          title="Sửa"
                          onClick={() => handleEditClick(row)}
                        >
                          <Edit size={18} />
                        </button>
                        <button
                          className="text-red-600 hover:text-red-800"
                          title="Xóa"
                          onClick={() => handleDeleteClick(row)}
                        >
                          <Trash size={18} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <AddQuickMessageModal
        isOpen={showAddModal}
        setIsOpen={setShowAddModal}
        shop={shop}
        editingQuickMessage={editingQuickMessage}
        setEditingQuickMessage={setEditingQuickMessage}
        getQuickMessages={getQuickMessages}
      />

      <CopyShopDataModal
        isOpen={showCopyModal}
        setIsOpen={setShowCopyModal}
        onSuccess={async () => {
          await getQuickMessages();
          if (refreshTags) await refreshTags();
        }}
      />
    </>
  );
}
